module.exports = __webpack_public_path__ + "static/media/DSC_0063.2fc09a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0063.jpg
// module id = 625
// module chunks = 0